/* eslint-disable no-bitwise */
import { TextDecoder } from 'util';

export const formatSeconds = (value: number) => {
  return `${Math.floor(value)}s`;
};

const bytesToKb = (value: number): number => {
  return value / 1024;
};

interface ITimeRange {
  start: number;
  end: number;
}

export const formatTimeRanges = (timeRangesObject: TimeRanges): ITimeRange[] => {
  const formattedRanges: ITimeRange[] = [];

  for (let i=0; i < timeRangesObject.length; i++) {
    formattedRanges.push({
      start: timeRangesObject.start(i),
      end: timeRangesObject.end(i)
    });
  }

  return formattedRanges;
};

export const formatBandwidth = (bandwidth: number): string => {
  const formatBandwidth = bytesToKb(bandwidth);

  return `${formatBandwidth.toFixed(2)} Kbps`;
};

export const formatBytesAsKb = (value: number): string => {
  const valueFormat = bytesToKb(value).toFixed(2);
  return `${valueFormat} KB`;
};

export const base64DecodeUint8Array = (input: string) => {
  const raw = window.atob(input);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++)
    array[i] = raw.charCodeAt(i);

  return array;
};

export const Uint8ArrayToString = (input: Uint8Array) => {
  const u8 = new Uint8Array(input);
  const decoder = new TextDecoder('utf8');
  return decoder.decode(u8);
};

export const extractContentId = (initData: string) => {
  return initData.substring(initData.indexOf('skd://') + 6);
};

export const base64EncodeUint8Array = (input: Uint8Array) => {
  const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN;
    chr3 = i < input.length ? input[i++] : Number.NaN;

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output += keyStr.charAt(enc1) + keyStr.charAt(enc2)
      + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }
  return output;
};

export const arrayToString = (array: Uint8Array) => {
  const uint16array = new Uint16Array(array.buffer);
  return String.fromCharCode.apply(null, uint16array as unknown as number[]);
};
